// COMPONENTS
import DefaultButton from "../buttons/default.button";

const DEFAULT_CLASSNAMES = {
  form: "w-[90%] border-animate rounded-2xl shadow-lg  flex flex-col items-center gap-4 p-8 bg-gray-200",
  header: "font-ubuntuBold",
  buttonContainer: "flex justify-end w-full px-4 py-2",
  inputContainer: "flex flex-wrap gap-4 justify-evenly",
};
const DefaultModalForm = ({
  header = "",
  classNames = DEFAULT_CLASSNAMES,
  saveButton = { handleClick: () => {}, loading: false },
  children,
}) => {
  return (
    <form className={classNames?.form || DEFAULT_CLASSNAMES.form}>
      <h1 className={classNames?.header || DEFAULT_CLASSNAMES.header}>
        {header}
      </h1>
      <div
        className={
          classNames?.buttonContainer || DEFAULT_CLASSNAMES.buttonContainer
        }
      >
        <DefaultButton
          handleClick={saveButton.handleClick}
          loading={saveButton.loading}
        >
          Save
        </DefaultButton>
      </div>
      <div
        className={
          classNames.inputContainer || DEFAULT_CLASSNAMES.inputContainer
        }
      >
        {children}
      </div>
    </form>
  );
};

export default DefaultModalForm;
